import { Navigate, Outlet } from "react-router";
import { authService } from "../../services/authService";
import { KycProvider } from "../../context/KycContext";
import { PermissionsProvider } from "../../context/PermissionsContext";

/**
 * Componente de rota protegida que verifica se o usuário está autenticado
 * Redireciona para a página de login se o usuário não estiver autenticado
 * Apenas rotas protegidas terão acesso aos contexts de KYC e Permissions
 */
const ProtectedRoute = () => {
  const isAuthenticated = authService.isAuthenticated();

  // Redireciona para a página de login se não estiver autenticado
  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  // Renderiza as rotas filhas se estiver autenticado, envolvidas pelos providers
  return (
    <KycProvider>
      <PermissionsProvider>
        <Outlet />
      </PermissionsProvider>
    </KycProvider>
  );
};

export default ProtectedRoute;
